import type { TOC } from '@ember/component/template-only';
import { LinkTo } from '@ember/routing';
import { t } from 'ember-intl';
import { PhGraduationCap } from 'ember-phosphor-icons';
import BenefitCard from 'tio-employee/components/dashboard-kit/benefit-card';
import type { ProgramSummary } from 'tio-employee/utils/partner-dashboard/sources/ta-analytics';
import type { WidgetComponentSignature } from 'tio-employee/utils/partner-dashboard/registry';

/** Pertinent card: each launched TA program with its eligible employees and requests in review. */
const TaProgramsWidget: TOC<WidgetComponentSignature<ProgramSummary[]>> = <template>
  <BenefitCard
    @title={{t "partner_dashboard.programs.title"}}
    @icon={{PhGraduationCap}}
    @actionLabel={{t "partner_dashboard.programs.view_all"}}
    @actionRoute="authenticated.admin.tuition-assistance.dashboard"
    data-test-partner-dashboard-ta-programs
  >
    {{#if @data.length}}
      <ul class="tio-col gap-3" role="list">
        {{#each @data key="id" as |program|}}
          <li class="tio-col-extra-tight" data-test-partner-dashboard-program={{program.id}}>
            <LinkTo
              @route="authenticated.admin.tuition-assistance.program-templates.show"
              @model={{program.id}}
              class="tio-text-base-semibold app-text-link"
            >{{program.name}}</LinkTo>
            <span class="tio-row-tight flex-wrap tio-text-sm-medium tio-fg-secondary">
              {{#if (neq program.eligible null)}}
                <span>{{t "partner_dashboard.programs.eligible" count=program.eligible}}</span>
              {{/if}}
              <span>{{t "partner_dashboard.programs.in_review" count=program.inReview}}</span>
            </span>
          </li>
        {{/each}}
      </ul>
    {{else}}
      <p class="tio-text-sm-medium tio-fg-secondary">{{t "partner_dashboard.programs.empty"}}</p>
    {{/if}}
  </BenefitCard>
</template>;

export default TaProgramsWidget;
